// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.device-picker {
  position: relative;
}

.device-picker-btn.has-device {
  width: auto;
  padding: 0 0.6rem;
  gap: 0.4rem;
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.device-picker-name {
  max-width: 9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  font-weight: 600;
}

.device-panel {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 1100;
  display: grid;
  gap: 0.6rem;
  width: min(24rem, calc(100vw - 2rem));
  max-height: min(75vh, 34rem);
  padding: 1rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-sm);
  box-shadow: 0 12px 36px var(--shadow-primary);
  grid-template-rows: auto auto auto auto minmax(0, 1fr);
}

.device-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.device-panel-head h2 {
  margin: 0;
  font-size: 1.3rem;
}

.device-panel-hint {
  margin: 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.device-search {
  position: relative;
  display: flex;
  align-items: center;
  color: var(--text-tertiary);
}

.device-search svg {
  position: absolute;
  left: 0.8rem;
  pointer-events: none;
}

.device-search input {
  width: 100%;
  padding-left: 2.4rem;
  background: var(--bg-primary);
}

.device-clear {
  justify-self: start;
  min-height: 32px;
  padding: 0;
  background: transparent;
  color: var(--signal);
  font-size: 0.85rem;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-align: left;
}

.device-list {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  border-top: 1px solid var(--border-primary);
}

.device-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  min-height: 42px;
  padding: 0.5rem 0.25rem;
  border-bottom: 1px solid var(--border-primary);
  background: transparent;
  color: var(--text-primary);
  font-size: 0.95rem;
  text-align: left;
}

.device-option:hover {
  background: var(--bg-tertiary);
}

.device-option.active {
  color: var(--accent-primary);
  font-weight: 700;
}

.device-empty {
  padding: 0.75rem 0.25rem;
  color: var(--text-secondary);
}

@media (max-width: 680px) {
  .device-picker {
    position: static;
  }

  .device-panel {
    position: fixed;
    top: calc(var(--header-height) + 4px);
    left: 1rem;
    right: 1rem;
    width: auto;
  }

  .device-picker-name {
    display: none;
  }

  .device-picker-btn.has-device {
    width: 38px;
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DevicePicker/DevicePicker.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,aAAa;EACb,WAAW;EACX,qCAAqC;EACrC,4BAA4B;EAC5B,aAAa;EACb,+BAA+B;EAC/B,yCAAyC;EACzC,+BAA+B;EAC/B,6CAA6C;EAC7C,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,8CAA8C;EAC9C,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,qCAAqC;IACrC,UAAU;IACV,WAAW;IACX,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;AACF","sourcesContent":[".device-picker {\n  position: relative;\n}\n\n.device-picker-btn.has-device {\n  width: auto;\n  padding: 0 0.6rem;\n  gap: 0.4rem;\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.device-picker-name {\n  max-width: 9rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  font-weight: 600;\n}\n\n.device-panel {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 1100;\n  display: grid;\n  gap: 0.6rem;\n  width: min(24rem, calc(100vw - 2rem));\n  max-height: min(75vh, 34rem);\n  padding: 1rem;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-secondary);\n  border-radius: var(--radius-sm);\n  box-shadow: 0 12px 36px var(--shadow-primary);\n  grid-template-rows: auto auto auto auto minmax(0, 1fr);\n}\n\n.device-panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.device-panel-head h2 {\n  margin: 0;\n  font-size: 1.3rem;\n}\n\n.device-panel-hint {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.device-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  color: var(--text-tertiary);\n}\n\n.device-search svg {\n  position: absolute;\n  left: 0.8rem;\n  pointer-events: none;\n}\n\n.device-search input {\n  width: 100%;\n  padding-left: 2.4rem;\n  background: var(--bg-primary);\n}\n\n.device-clear {\n  justify-self: start;\n  min-height: 32px;\n  padding: 0;\n  background: transparent;\n  color: var(--signal);\n  font-size: 0.85rem;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  text-align: left;\n}\n\n.device-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  border-top: 1px solid var(--border-primary);\n}\n\n.device-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  width: 100%;\n  min-height: 42px;\n  padding: 0.5rem 0.25rem;\n  border-bottom: 1px solid var(--border-primary);\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 0.95rem;\n  text-align: left;\n}\n\n.device-option:hover {\n  background: var(--bg-tertiary);\n}\n\n.device-option.active {\n  color: var(--accent-primary);\n  font-weight: 700;\n}\n\n.device-empty {\n  padding: 0.75rem 0.25rem;\n  color: var(--text-secondary);\n}\n\n@media (max-width: 680px) {\n  .device-picker {\n    position: static;\n  }\n\n  .device-panel {\n    position: fixed;\n    top: calc(var(--header-height) + 4px);\n    left: 1rem;\n    right: 1rem;\n    width: auto;\n  }\n\n  .device-picker-name {\n    display: none;\n  }\n\n  .device-picker-btn.has-device {\n    width: 38px;\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
